// Imports
import $ from 'jquery';
import attachEnterAsClick from 'utils/attachEnterAsClick';

// The functions to call
initMobileNavTabs();

// Functions
function initMobileNavTabs() {
    const tabGroupClass = '.js-mobile-nav-tabs';
    const tabItemClass = '.js-mobile-nav-tab-item';

    // early return if no component found
    if (!$(tabItemClass).length) { return; }
    // Handle tab item click
    $(tabItemClass).click(function () {
        // Remove all active class from siblings
        $(this).closest(tabGroupClass).find(tabItemClass).removeClass('active');
        $(this).closest(tabGroupClass).find(tabItemClass).attr('tabindex', '0');

        // Add active class it itself
        $(this).addClass('active');
        $(this).attr('tabindex', '');

        // Find the tab content selector and show / hide the content
        const tabContentId = $(this).closest(tabGroupClass).data('id');
        if (tabContentId) {
            // Hide all immidiate children of the tab content
            $(`#${tabContentId} > *`).hide();

            // Show the children of the tab content with the same index as the active tab item
            $(`#${tabContentId} > *:nth-child(${($(this).index() + 1)})`).fadeIn(300);
        }

        // Trigger a windows resize call to cause some plugins like float table header to kick off
        $(window).resize();
    });
    attachEnterAsClick($(tabItemClass));

    // On init, programatically click the active tab, if no active tab present click the first tab
    if ($(`${tabItemClass}.active`).length) {
        $(`${tabItemClass}.active`).click();
    } else {
        $(`${tabItemClass}:first-child`).click();
    }
}

